import type { ReactNode } from 'react'

/**
 * La bibliothèque d'icônes de la console — TRACÉS EXTRAITS TELS QUELS du
 * `const ICONS` d'origine (`index.html`), par script, pour qu'aucun ne soit
 * redessiné.
 *
 * La seule transformation appliquée aux tracés est la syntaxe des attributs
 * (`stroke-width` → `strokeWidth`, `class` → `className`), imposée par JSX.
 */
const TRACES: Record<string, ReactNode> = {
  phone: (
    <><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" /></>
  ),
  chat: (
    <><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" /></>
  ),
  globe: (
    <><circle cx="12" cy="12" r="10" /><path d="M2 12h20M12 2a15.3 15.3 0 0 1 0 20 15.3 15.3 0 0 1 0-20z" /></>
  ),
  more: (
    <><circle cx="5" cy="12" r="1" /><circle cx="12" cy="12" r="1" /><circle cx="19" cy="12" r="1" /></>
  ),
  dispatch: (
    <><rect x="3" y="3" width="7" height="7" rx="1.4" /><rect x="14" y="3" width="7" height="7" rx="1.4" /><rect x="14" y="14" width="7" height="7" rx="1.4" /><rect x="3" y="14" width="7" height="7" rx="1.4" /></>
  ),
  users: (
    <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></>
  ),
  user: (
    <><circle cx="12" cy="7" r="4" /><path d="M5.5 21a7.5 7.5 0 0 1 13 0" /></>
  ),
  plus: (
    <><path d="M12 5v14M5 12h14" /></>
  ),
  check: (
    <><path d="M20 6L9 17l-5-5" /></>
  ),
  arrow: (
    <><path d="M5 12h14M12 5l7 7-7 7" /></>
  ),
  x: (
    <><path d="M18 6L6 18M6 6l12 12" /></>
  ),
  package: (
    <><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12" /></>
  ),
  clock: (
    <><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></>
  ),
  wallet: (
    <><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" /><path d="M3 5v14a2 2 0 0 0 2 2h16v-5" /><path d="M18 12a2 2 0 0 0 0 4h4v-4z" /></>
  ),
  logout: (
    <><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5M21 12H9" /></>
  ),
  gear: (
    <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></>
  ),
  chevron: (
    <><path d="M6 9l6 6 6-6" /></>
  ),
  receipt: (
    <><path d="M5 2v20l2.2-1.4L9.4 22l2.2-1.4L13.8 22l2.2-1.4L18.2 22l1.8-1.2V2l-1.8 1.2L16 1.8 13.8 3.2 11.6 1.8 9.4 3.2 7.2 1.8z" /><path d="M8 8h8M8 12h8M8 16h5" /></>
  ),
  book: (
    <><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" /></>
  ),
  scale: (
    <><path d="M12 3v18M6 21h12" /><path d="M6 7l-3 6h6zM18 7l-3 6h6z" /><path d="M6 7l6-2 6 2" /></>
  ),
  chart: (
    <><path d="M3 3v18h18" /><path d="M7 14l3-4 3 3 4-6" /></>
  ),
  grid: (
    <><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M3 15h18M9 3v18" /></>
  ),
  download: (
    <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="M7 10l5 5 5-5M12 15V3" /></>
  ),
  shield: (
    <><path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z" /></>
  ),
  edit: (
    <><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4z" /></>
  ),
  mail: (
    <><rect x="2" y="4" width="20" height="16" rx="2" /><path d="M22 7l-10 6L2 7" /></>
  ),
  printer: (
    <><path d="M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2" /><rect x="6" y="14" width="12" height="8" /></>
  ),
  spark: (
    <><path className="ic-fill" d="M12 2l2.5 6.9L21 11.4l-6.5 2.5L12 21l-2.5-7.1L3 11.4l6.5-2.5z" /></>
  ),
  star: (
    <><path className="ic-fill" d="M12 2.5l2.9 5.9 6.5.95-4.7 4.6 1.1 6.5L12 17.4l-5.8 3.05 1.1-6.5-4.7-4.6 6.5-.95z" /></>
  ),
  pin: (
    <><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></>
  ),
  send: (
    <><path d="M22 2L11 13M22 2l-7 20-4-9-9-4z" /></>
  ),
  /* Ajoutées avec les alertes GPS (0052) : mêmes tracés que le portail SaaS (Icone.tsx de webapp-ts). */
  bell: (
    <><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.7 21a2 2 0 0 1-3.4 0" /></>
  ),
  trash: (
    <><path d="M3 6h18M8 6V4h8v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /><path d="M10 11v6M14 11v6" /></>
  ),
  alert: (
    <><path d="M12 3l10 18H2z" /><path d="M12 10v5M12 18.2h.01" /></>
  ),
  refresh: (
    <><path d="M21 12a9 9 0 0 1-15.5 6.2M3 12a9 9 0 0 1 15.5-6.2" /><path d="M21 4v5h-5M3 20v-5h5" /></>
  ),
}

export type NomIcone = keyof typeof TRACES

/**
 * `viewBox` vient de `ic()` : c'est la classe `.ic` (globale, feuille de style
 * de la console) qui porte toute la mise en forme — `width:1em`,
 * `stroke:currentColor`, `fill:none`, `stroke-width:2`. `classe` reproduit le
 * second paramètre de `ic(name, cls)`, ajouté après `ic` dans l'attribut.
 */
export function Icone({ nom, classe }: { nom: NomIcone; classe?: string }) {
  return (
    <svg className={classe ? `ic ${classe}` : 'ic'} viewBox="0 0 24 24">
      {TRACES[nom]}
    </svg>
  )
}

/* Logo SwiftDeliver « colis + chevrons de vitesse » — version fond clair et
   version fond sombre. Les classes `chev c1/c2/c3` sont conservées : c'est
   sur elles que joue l'animation CSS des chevrons (`.logo-anim`). */
export function Logo() {
  return (
    <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" fill="none">
      <rect x="14.5" y="10.5" width="20" height="20" rx="4.5" fill="#0F8A6A" />
      <path d="M22 10.5v7.2l2.5-1.7 2.5 1.7v-7.2z" fill="#EAF6F1" />
      <path className="chev c1" d="M4.5 15.5h6.5" stroke="#0F8A6A" strokeWidth="2.6" strokeLinecap="round" />
      <path className="chev c2" d="M2.5 20.5h8.5" stroke="#0F8A6A" strokeWidth="2.6" strokeLinecap="round" />
      <path className="chev c3" d="M4.5 25.5h6.5" stroke="#0F8A6A" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  )
}

export function LogoSombre() {
  return (
    <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" fill="none">
      <rect x="14.5" y="10.5" width="20" height="20" rx="4.5" fill="#7FCBB4" />
      <path d="M22 10.5v7.2l2.5-1.7 2.5 1.7v-7.2z" fill="#0B6B52" />
      <path className="chev c1" d="M4.5 15.5h6.5" stroke="#7FCBB4" strokeWidth="2.6" strokeLinecap="round" />
      <path className="chev c2" d="M2.5 20.5h8.5" stroke="#7FCBB4" strokeWidth="2.6" strokeLinecap="round" />
      <path className="chev c3" d="M4.5 25.5h6.5" stroke="#7FCBB4" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  )
}
